import { gql } from "@apollo/client";

export const COURSE_FRAGMENT = gql`
  fragment CourseFragment on Course {
    title
    id
    slug
    price
    nsdcCertified
    coverImage {
      url
    }
    coaches {
      firstName
      lastName
      headline
      about
      userType
      profilePicture {
        filename
        id
        url
      }
    }
  }
`;

export const SERIES_FRAGMENT = gql`
  fragment SeriesFragment on Series {
    title
    id
    slug
    coverImage {
      url
    }
  }
`;

export const PLAN_FRAGMENT = gql`
  fragment PlanFragment on Plan {
    title
    chargebeeName
    id
  }
`;
